import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import MessagingSettings from '../../components/Messages/MessagingSettings';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';

const MessagingSettingsPage = () => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const navigate = useNavigate();
    const onClickGoBack = () => {
        navigate(`/adminCentre/host`);
    };
    const theme = useTheme();

    return (
        <Grid
            sx={{
                width: '100%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <MessagingSettings />
            <Grid
                sx={{
                    height: isMobile ? '5%' : '5%',
                    display: isMobile || isIpad ? 'none' : 'flex', // Hide on mobile
                }}
            >
                {' '}
                <CustomButton
                    onClick={onClickGoBack}
                    color='primary'
                    sx={{
                        marginLeft: '-8px',
                        '&:hover': {
                            cursor: 'pointer',
                            color: theme.palette.textAccent.main,
                            backgroundColor: 'transparent',
                            background: 'none',
                        },
                    }}
                >
                    <ArrowBackIcon />{' '}
                    {isMobile ? null : (
                        <Typography
                            sx={{
                                fontSize: '12px',
                                paddingLeft: '5px',
                            }}
                        >
                            Back to Admin Centre
                        </Typography>
                    )}
                </CustomButton>
            </Grid>
        </Grid>
    );
};

export default MessagingSettingsPage;
